import _get from 'lodash/get'

export const get_mailchimp = state => _get(state, 'mailchimp.mailchimp')
export const get_mailchimp_redirect_uri = state => _get(state, 'mailchimp.redirect_uri')
